import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Models
export interface permission {
    id: number,
    name: string
}

// Permissions state
export interface permissionsState {
    isLoaded: boolean,
    isOpen: boolean,
    permissions: permission[],
    selectedIds: number[]
}

const initialPermissionsState: permissionsState = {
    isLoaded: false,
    isOpen: false,
    permissions: [],
    selectedIds: []
}

// Permissions slice
export const permissionsSlice = createSlice({
    name: 'permissions',
    initialState: initialPermissionsState,
    reducers: {
        setIsLoaded: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isLoaded = payload
        },
        setPermissions: ( state, {payload}: PayloadAction<permission[]> ) => {
            state.permissions = payload
        },
        toggleId: ( state, {payload}: PayloadAction<number> ) => {
            let index = state.selectedIds.findIndex( id => id === payload )
            if( index !== -1 )
                state.selectedIds.splice( index, 1 )
            else
                state.selectedIds.push(payload)
        },
        setSelectedIds: ( state, {payload}: PayloadAction<number[]> ) => {
            state.selectedIds = payload
        },
        setIsOpen: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isOpen = payload
        },
    }
})